<template>
  <div class="col-sm-12">
    <br />
    <br />
    <h3>Assigning awarded points to a program.</h3>
    <table>
      <tbody>
        <tr>
          <td>
            <p class="NOTE">
              Incentiweb customers often run specially defined "programs" that include branding, advertisement and a defined time period for earning
              an award. To get your awarded points assigned to a program, you need to know either the exact program name or the program ID. Refer to
              the table below to find the name and/or id of the programs you are currently using.
            </p>

            <p class="NOTE">
              Once you know the name or number of the program you are using, put it in the <em>program_id</em> or <em>program_name</em> column of the
              access or excel template you are uploading. When you finalize the points, the process will automatically assign the transaction to the
              proper program and your reports will reflect the correct program total.
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <table class="table">
              <thead>
                <tr>
                  <th colspan="3" class="note2 text-center">Authorized Programs</th>
                </tr>
                <tr>
                  <th scope="col">co/location</th>
                  <th scope="col">program Name</th>
                  <th scope="col">Program ID</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Divvy Engagement Solutions</td>
                  <td>Feb17TestProgram</td>
                  <td>500294</td>
                </tr>

                <tr>
                  <td>Divvy Engagement Solutions</td>
                  <td>Feb17TestProgram</td>
                  <td>500294</td>
                </tr>

                <tr>
                  <td>Divvy Engagement Solutions</td>
                  <td>Mahesh Yadav</td>
                  <td>500293</td>
                </tr>

                <tr>
                  <td>Divvy Engagement Solutions</td>
                  <td>Test Annual Awards Program-100</td>
                  <td>500291</td>
                </tr>

                <tr>
                  <td>Divvy Engagement Solutions</td>
                  <td>Test Service Anniversary Award</td>
                  <td>500285</td>
                </tr>

                <tr>
                  <td>Divvy Engagement Solutions</td>
                  <td>testing program</td>
                  <td>500288</td>
                </tr>
              </tbody>
            </table>
            <br />
            <br />
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <br />
  </div>
</template>
<script>
export default {
  name: 'Program',
};
</script>
<style scoped>
table {
  border: 0px solid transparent;
  font-size: 14px;
  width: inherit;
}
fieldset {
  padding: 0.35em 0.625em 0.75em;
  margin: 0 5px;
  border: 1px solid silver;
  border-radius: 8px;
}
legend {
  width: auto;
  padding: 10px;
  font-size: 15px;
  color: #333;
  border: 0;
  border-bottom: none;
}
</style>
